import PropTypes from 'prop-types';
import {
  CART_ESPOT_PINSTRIPE,
  CART_ESPOT_TOP,
  CART_ESPOT_IE
} from '../constants';
import cx from 'classnames';
import Espot from '@app/components/common/Espot/Espot';
import { useSelector } from 'react-redux';
import {
  USER_TYPE_GUEST,
  ESPOT_VARIANTS
} from '@app/constants/commonConstants';

const TopEspots = ({ espotData }) => {
  const userType = useSelector(state => state.common.userType);
  const isLoggedIn = !!(userType && userType !== USER_TYPE_GUEST);
  const shoppingPreferencesEnabled = useSelector(
    s => !!s.dealer.shoppingPreferencesEnabled
  );
  const pccMarketingRibbonShoppingCartFeatureFlag = useSelector(
    s => s.featureFlag?.PCC_MarketingRibbonShoppingCartFeatureFlag
  );
  const hasPinstripeEnabled = !!espotData[CART_ESPOT_PINSTRIPE];
  const hasTopEspotEnabled =
    isLoggedIn && shoppingPreferencesEnabled && !!espotData[CART_ESPOT_TOP];
  const isUserOnIe = /MSIE|Trident/.test(navigator.userAgent);
  const hasIeSpotEnabled =
    isUserOnIe && !isLoggedIn && !!espotData[CART_ESPOT_IE];

  return (
    <>
      {hasPinstripeEnabled && !pccMarketingRibbonShoppingCartFeatureFlag && (
        <Espot
          html={espotData[CART_ESPOT_PINSTRIPE]}
          className="d-print-none"
          variant={ESPOT_VARIANTS.PINSTRIPE}
        />
      )}
      {!hasPinstripeEnabled && hasTopEspotEnabled && (
        <Espot
          html={espotData[CART_ESPOT_TOP]}
          className="d-print-none"
          variant={ESPOT_VARIANTS.PINSTRIPE}
        />
      )}
      {hasIeSpotEnabled && (
        <Espot
          html={espotData[CART_ESPOT_IE]}
          className={cx('d-print-none', { 'mt-3': hasPinstripeEnabled })}
          variant={ESPOT_VARIANTS.PINSTRIPE}
        />
      )}
    </>
  );
};

export default TopEspots;

const espotObjectPropTypes = PropTypes.shape({
  [CART_ESPOT_PINSTRIPE]: PropTypes.string,
  [CART_ESPOT_TOP]: PropTypes.string,
  [CART_ESPOT_IE]: PropTypes.string
});

TopEspots.propTypes = {
  espotData: espotObjectPropTypes.isRequired
};
